import React, { Component } from 'react';
import { FormGroup,  FormFeedback, Input, Row, Col, Label } from 'reactstrap';
import PropTypes from 'prop-types';

import * as Validations from '../validation/validations';
import * as FormLogic from './FormLogic'
import { run, validationRunner } from '../validation/validationRunner'

const fieldValidations = [
  validationRunner("Telephone", "Telefoon vast", Validations.telephoneNumber, Validations.maxLength(32)),
  validationRunner("Mobile", "Telefoon mobiel", Validations.telephoneNumber, Validations.maxLength(32)),
  validationRunner("Email", "E-mail", Validations.email, Validations.required, Validations.maxLength(255)),
  validationRunner("EmailDuplicate", "Herhaling e-mail", Validations.required, Validations.email, Validations.mustMatch("Email", "E-mail"), Validations.maxLength(255)),
  validationRunner("ParentName", "Naam ouder / verzorger", Validations.requiredMinor, Validations.maxLength(255)),
  validationRunner("ParentTelephone", "Telefoon ouder / verzorger", Validations.requiredMinor, Validations.telephoneNumber, Validations.maxLength(32)),
  validationRunner("ParentEmail", "E-mail ouder / verzorger", Validations.requiredMinor, Validations.email, Validations.maxLength(255)),
  validationRunner("ParentEmailDuplicate", "Herhaling e-mail", Validations.requiredMinor, Validations.email, Validations.mustMatch("ParentEmail", "E-mail ouder / verzorger"), Validations.maxLength(255)),
]


class RegistrationFormCommData extends Component {
  constructor(props) {
    super(props);
    this.validate = false;
    this.state = {
      validationErrors: [],
      fieldsTouched: [],
      minor: props.minor, // store in state for validations

      Telephone: "",
      Mobile: "",
      Email: "",
      EmailDuplicate: "",
      ParentName: "",
      ParentTelephone: "",
      ParentEmail: "",
      ParentEmailDuplicate: "",
    };

    this.handleChange = FormLogic.handleChange.bind(this);
    this.handleChangeCapitalizeWords = FormLogic.handleChangeCapitalizeWords.bind(this);
    this.errorFor = FormLogic.errorFor.bind(this);
    this.checkInvalid = FormLogic.checkInvalid.bind(this);
    this.setFieldsTouched = FormLogic.setFieldsTouched.bind(this);
    this.handleChangeToUpper = FormLogic.handleChangeToUpper.bind(this);

    this.run = run.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({minor: nextProps.minor})
  }
  componentDidUpdate() {
    this.runValidations();
  }

  runValidations(ignoreTouched) {
    if (ignoreTouched) {
      this.validate = true;
    }
    return this.run(fieldValidations);
  }

  ignorePaste(e) {
    e.preventDefault();
  }

  getFormValues() {
    return {
      "Telephone" : this.state.Telephone,
      "Mobile" : this.state.Mobile,
      "Email" : this.state.Email,
      "ParentName" : this.state.ParentName,
      "ParentTelephone" : this.state.ParentTelephone,
      "ParentEmail" : this.state.ParentEmail
    }
  }

  render() {
    return (
      <div>
        <Row>
          <Col md={{size:3, offset:1}} />
          <Col md={6}>
            <h2>
              Communicatiegegevens
            </h2>
          </Col>
        </Row>

        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label"  >Telefoon vast </Label>
          </Col>
          <Col md={7}>
            <Input
              name="Telephone"
              autoComplete="ignored-123456"
              value={this.state.Telephone}
              onChange={this.handleChange}
              ref={instance => { this.commDataForm = instance; }}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("Telephone")}
              className="Input" />
            <FormFeedback>{this.errorFor("Telephone")}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label"  >Telefoon mobiel </Label>
          </Col>
          <Col md={7}>
            <Input
              name="Mobile"
              autoComplete="ignored-123456"
              value={this.state.Mobile}
              onChange={this.handleChange}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("Mobile")}
              className="Input" />
            <FormFeedback>{this.errorFor("Mobile")}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label"  >E-mail * </Label>
          </Col>
          <Col md={7}>
            <Input
              name="Email"
              autoComplete="ignored-123456"
              value={this.state.Email}
              onChange={this.handleChange}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("Email")}
              onPaste={this.ignorePaste}
              className="Input" />
            <FormFeedback>{this.errorFor("Email")}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label"  >Herhaal e-mail * </Label>
          </Col>
          <Col md={7}>
            <Input
              name="EmailDuplicate"
              autoComplete="ignored-123456"
              value={this.state.EmailDuplicate}
              onChange={this.handleChange}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("EmailDuplicate")}
              onPaste={this.ignorePaste}
              className="Input" />
            <FormFeedback>{this.errorFor("EmailDuplicate")}</FormFeedback>
          </Col>
        </FormGroup>

        {/* Alleen voor onder de 16, visibility nav van PersonDOB */}

        <div hidden={!this.state.minor} className="MinorCommBlock">
          <Row>
            <Col md={{size:10, offset:1}} >
              <div className="FormDescription">
                De persoon die je wilt aanmelden is jonger dan 16. Voor deze
                aanmelding hebben we toestemming van een ouder/verzorger nodig.
                Na het afronden van deze aanmelding wordt een bevestigingsmail
                gestuurd waar de ouder/verzorger op moet reageren om deze aanmelding compleet te maken.
              </div>
            </Col>
          </Row>

          <FormGroup row>
            <Col md={{size:3, offset:1}} >
              <Label className="Label"  >Naam ouder / verzorger * </Label>
            </Col>
            <Col md={7}>
              <Input
                name="ParentName"
                autoComplete="ignored-123456"
                value={this.state.ParentName}
                onChange={this.handleChange}
                onBlur={this.setFieldsTouched}
                innerRef={(input) => { this.ParentName = input; }}
                invalid={this.checkInvalid("ParentName")}
                className="Input" />
              <FormFeedback >{this.errorFor("ParentName")}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md={{size:3, offset:1}} >
              <Label className="Label"  >Telefoon ouder / verzorger * </Label>
            </Col>
            <Col md={7}>
              <Input
                name="ParentTelephone"
                autoComplete="ignored-123456"
                value={this.state.ParentTelephone}
                onChange={this.handleChange}
                onBlur={this.setFieldsTouched}
                innerRef={(input) => { this.ParentTelephone = input; }}
                invalid={this.checkInvalid("ParentTelephone")}
                className="Input" />
              <FormFeedback>{this.errorFor("ParentTelephone")}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md={{size:3, offset:1}} >
              <Label className="Label"  >E-mail ouder / verzorger * </Label>
            </Col>
            <Col md={7}>
              <Input
                name="ParentEmail"
                autoComplete="ignored-123456"
                value={this.state.ParentEmail}
                onChange={this.handleChange}
                onBlur={this.setFieldsTouched}
                onPaste={this.ignorePaste}
                innerRef={(input) => { this.ParentEmail = input; }}
                invalid={this.checkInvalid("ParentEmail")}
                className="Input" />
              <FormFeedback >{this.errorFor("ParentEmail")}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md={{size:3, offset:1}} >
              <Label className="Label"  >Herhaal e-mail ouder / verzorger * </Label>
            </Col>
            <Col md={7}>
              <Input
                name="ParentEmailDuplicate"
                autoComplete="ignored-123456"
                value={this.state.ParentEmailDuplicate}
                onChange={this.handleChange}
                onBlur={this.setFieldsTouched}
                onPaste={this.ignorePaste}
                innerRef={(input) => { this.ParentEmailDuplicate = input; }}
                invalid={this.checkInvalid("ParentEmailDuplicate")}
                className="Input" />
              <FormFeedback>{this.errorFor("ParentEmailDuplicate")}</FormFeedback>
            </Col>
          </FormGroup>
        </div>
    </div>
    );
  }
}
RegistrationFormCommData.propTypes = {
  minor: PropTypes.bool.isRequired,
}

export default RegistrationFormCommData



// WEBPACK FOOTER //
// ./src/registrationform/RegistrationFormCommData.jsx